<template>
  <div>
    <BulkOpsHeader
      @new="newDialog = true"
    >
      Form Import (Deprecated)
    </BulkOpsHeader>
    <v-alert
      :value="true"
      type="warning"
      style="margin-bottom: 20px;"
    >
      This bulk operation has been deprecated and this data is available for historial purposes only.
    </v-alert>
    <BulkOpsTable
      :rows.sync="formOps"
      :headers="headers"
      :totalRows="pagination.totalRows"
      :pagination="pagination"
      @fetch="pagination=arguments[0]"
    >
      <template v-slot:default="prop">
        <td>
          <span
            v-if="prop.row.status == 'running'"
          >
            <b>Running...</b>
          </span>
          <span
            v-else
          >
            <b>Imported {{prop.row.count}} Forms</b>
          </span>
          <span
            v-if="prop.row.failed > 0"
            style="color: red;"
          >
            ({{prop.row.failed}} failed!)
          </span>
          <div
            v-if="JSON.parse(prop.row.import_json).tags"
          >
            <b>Add Tags: </b>
            <v-chip
              v-for="tag in JSON.parse(prop.row.import_json).tags"
              :key="tag"
              small
            >
              {{tag}}
            </v-chip>
          </div>
          <div
            v-if="JSON.parse(prop.row.import_json).active"
          >
            <b>Enabled</b>
          </div>
        </td>
        <td style="text-transform: capitalize;">
          <span
            v-if="prop.row.failed"
          >
            <v-btn
              flat
              color="red"
              small
              @click="getErrorFile(prop.row.id)"
            >
              Download Errors
            </v-btn>
          </span>
        </td>
        <td style="text-transform: capitalize;">
          {{prop.row.status}}
        </td>
      </template>
    </BulkOpsTable>
    <v-dialog
      v-model="newDialog"
      width="300"
    >
      <v-card>
        <v-card-text>
          New operations are disabled.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="newDialog = !newDialog"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import GlobalConstants from '@/globals'
import pagination from '@/components/global/pagination'
import BulkOpsHeader from '@/components/admin/bulkops/BulkOpsHeader'
import BulkOpsTable from '@/components/admin/bulkops/BulkOpsTable'
import BulkOpsDialog from '@/components/admin/bulkops/BulkOpsDialog'

export default {
  name: 'LegacyUserFormImport',
  components: {
    BulkOpsHeader,
    BulkOpsTable,
    BulkOpsDialog
  },
  mixins: [
    pagination
  ],
  data () {
    return {
      formOps: [],
      files: [],
      loading: false,
      pagination: {},
      totalRows: null,
      pages: null,
      newDialog: false,
      interval: null,
      filterFormTemplate: null,
      searching: null,
      formTemplates: [],
      formSearch: '',
      headers: [
        { text: 'Details', width: 180, sortable: false },
        { text: 'Files', width: 60, sortable: false },
        { text: 'Status', width: 60, sortable: false },
        { text: 'Run Time', width: 60, sortable: false },
        { text: 'Progress', width: 60, sortable: false },
      ],
      bulkOpActions: [
        {
          "title": "Operation Type (Create or Update)",
          "prop": "create",
          "type": "dropdown",
          "options": [
            {
              "name": "Create New Forms",
              "value": true
            },
            {
              "name": "Update Existing Forms",
              "value": false
            },
          ],
          "value": null,
          "hint": "Set whether you are creating new forms or updating existing ones",
          "required": true
        },
        {
          "title": "Add Additional Tags",
          "prop": "tags",
          "type": "tags",
          "type_scope": "userform",
          "value": null,
          "hint": "Apply Tags in addition to Tags in import file"
        },
        {
          "title": "Set Status",
          "prop": "status",
          "type": "dropdown",
          "options": GlobalConstants.StatusStrings,
          "value": null,
          "hint": "Set all created/updated forms to this status",
          "cond_req_prop": "create",
          "cond_req_value": true
        },
        {
          "type": "header",
          "title": "Advanced Options",
          "subtitle": "These options risk data loss if used improperly",
          "advanced": true
        },
        {
          "title": "Import Mode",
          "prop": "reset",
          "type": "dropdown",
          "advanced": true,
          "options": [
            {
              "name": "Reset Forms",
              "value": true
            },
            {
              "name": "Update Forms",
              "value": false
            },
          ],
          "value": false,
          "hint": "Set whether to update over existing data, or reset form and import",
          "required": true,
          "destructive": true
        },
      ]
    }
  },
  computed: {
    cantSubmit () {
      return this.files.length == 0
    }
  },
  created () {
    this.documentTitle('Form Import')
  },
  watch: {
    formSearch () {
      if (this.formSearch && this.formSearch.length > 3) {
        this.loadFormTemplates()
      }
    },
    newDialog () {
      if (!this.newDialog) {
        this.filterFormTemplate = null
      }
    }
  },
  methods: {
    handleFileUploads () {
      this.files = this.$refs.files.files
      if (this.files.length > 0) {
        this.canRun = true
      }
    },
    restartInterval () {
      clearInterval(this.interval)
      var countWorking = 0
      this.formOps.forEach((item) => {
        if (["finished", "failed"].indexOf(item.status) == -1)
          countWorking++
      })
      if (countWorking > 0) {
        this.interval = setInterval(() => {
          this.fetch()
        }, 5000)
      }
    },
    fetch () {
      this.loading = true
      api.bulkops.userform_import.list({
        pageNum: this.pagination.page, count: this.pagination.rowsPerPage, ordering: '-created_at'
      })
        .then(data => {
          this.formOps = data.results
          this.pagination.totalRows = data.count
          this.pagination.page = data.page_number
          this.loading = false
          this.componentCreated = true
          this.restartInterval()
        })
    },
    save (newOp) {
      let formData = new FormData()
      for( var i = 0; i < this.files.length; i++ ){
        let file = this.files[i]
        formData.append(`import_csv`, file)
      }
      var import_json = {}
      newOp.props.forEach((prop) => {
        if (prop.prop == 'template') {
          import_json['template'] = prop.value.value
        } else {
          if (prop.value !== null && prop.value !== "") {
            import_json[prop.prop] = prop.value
          }
        }
      })
      formData.append(`import_json`, JSON.stringify(import_json))
      api.bulkops.userform_import.save(formData)
      .then(() => {
        this.newDialog = false
        this.fetch()
      })
    },
    getErrorFile (obj) {
      this.loading = true
      api.bulkops.userform_import.downloadFile(obj)
      .then(response => {
        this.loading = false
        let blob = new Blob([response.data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = "UserForm_Import-" + obj + '.csv'
        link.click()
      })
    },
    loadFormTemplates () {
      this.searching = true
      api.formtemplate.formtemplate.list({ search: this.formSearch, count: 15 })
        .then(data => {
          this.searching = false
          this.formTemplates = data.results
        })
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>
